import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useBondsBondCCurrencyCode, useBondsBondIsRedacted } from '../../hooks';

export const BondsBondCCurrencyCode = (props: {
  withRedactedIcon?: boolean,
}) => {
  const {
    withRedactedIcon,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useBondsBondCCurrencyCode();
  const {
    data: redacted,
    isLoading: redactedIsLoading,
  } = useBondsBondIsRedacted('C_CURRENCY.CODE');
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading || redactedIsLoading}
      error={error}
      loadingValue="---"
      isBlocked={redacted}
      withRedactedIcon={withRedactedIcon}
    />
  );
};
